import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import { addEventListenerIfNotExists } from './common';

export default class ImageGallery {
    private readonly galleryItemSelector: string;
    private readonly moreElement: HTMLElement;

    constructor(galleryItemSelector: string, moreSelector: string) {
        this.galleryItemSelector = galleryItemSelector;
        this.moreElement = document.querySelector(moreSelector);
        this.init();
    }

    private init(): void {
        if (!this.galleryItemSelector)
            return;

        Fancybox.bind(this.galleryItemSelector,{});

        if (this.moreElement) {
            addEventListenerIfNotExists(this.moreElement, 'click', () => {
                let fourthElement = document.querySelectorAll(this.galleryItemSelector)[4] as HTMLElement;
                fourthElement.click();
            });
        }
    }
}
